import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
} from '@angular/core';
import { StytchService } from '../../services/stytch/stytch.service';
import { StytchB2B } from '@stytch/vanilla-js/b2b';
import { DocumentRefService } from '@callrail/looky/util';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'anbs-login',
  templateUrl: './login.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoginComponent implements OnInit {
  private stytchService = inject(StytchService);
  private documentService = inject(DocumentRefService);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    if (!customElements.get('stytch-login')) {
      customElements.define('stytch-login', StytchB2B);
    }
    this.route.queryParamMap.subscribe({
      next: (params) => {
        (
          this.documentService
            .nativeDocument()
            .getElementById('stytch-login') as any
        )?.render({
          ...this.stytchService.config(params),
        });
      },
    });
  }
}
